module.exports = __webpack_public_path__ + "static/3-f2615ba3e682fe7bc6dff7d504e17e5e.png";